module.exports = __webpack_public_path__ + "img/lock-check-mark.99aca999.svg";